import { render, staticRenderFns } from "./ab-img-previewer.vue?vue&type=template&id=0ff753d3&"
import script from "./ab-img-previewer.vue?vue&type=script&lang=js&"
export * from "./ab-img-previewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports